import { render, staticRenderFns } from "./BranchCustomerStatistics.vue?vue&type=template&id=5fb67424&"
import script from "./BranchCustomerStatistics.vue?vue&type=script&lang=ts&"
export * from "./BranchCustomerStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports